import { createReducer, on, State, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LoadPermissionsSuccess, LoadPermissions } from '../actions/app.actions';

export interface AppState extends EntityState<any> {
    loadPermissionsSuccess: boolean;

}

export const appAdapter: EntityAdapter<any> = createEntityAdapter<any>();


export const initialState: AppState = appAdapter.getInitialState({
    loadPermissionsSuccess: false

});


export interface PermissionState {
    permissions: AppState;
}

export const PermissionStateTracker: PermissionState = {
    permissions: initialState
};

const appReducer = createReducer(
    PermissionStateTracker,
    on(LoadPermissionsSuccess, (state, { permission }) => {
        return {
            ...state,
           // permissions: appAdapter.addAll(permission, PermissionStateTracker.permissions),
            permissions: appAdapter.addOne(permission, PermissionStateTracker.permissions),
            loadPermissionsSuccess: true

        };
    }),

);

export function reducer(state: PermissionState | undefined, action: Action) {
    return appReducer(state, action);
}




export const {

    selectAll,

} = appAdapter.getSelectors();




export const selectAllPermission = selectAll;
